import React from "react";
import Chart from "react-google-charts";
import { CardBody, Card, Label, Form, FormGroup, Col, Button, Input, Row } from 'reactstrap'

class MonitoringCommplaincesPieChart extends React.PureComponent {

    render() {
        return (<React.Fragment>
           
                {this.props && this.props.data && this.props.data.length > 0 ?
                   
                    <Chart
                        width={'500px'}
                        height={'300px'}
                        chartType="PieChart"
                        loader={<div className ="monitoring-chart-loader"/>}
                        data={this.props.data}
                        options={{
                            title: this.props.title,
                            is3D: true,
                            fontName: "open_sansregular",
                            legend: {
                                alignment: "center",
                                textStyle: {
                                    color: "233238",
                                    fontSize: 14
                                }
                            },
                            slices: [
                                {
                                    color: "#00b050"
                                },
                                {
                                    color: "#ff0000"
                                },
                                {
                                    color: "#3366cc"
                                }
                            ]
                        }}
                        rootProps={{ 'data-testid': '2' }}
                    /> 
                    : <div>No data Found!</div>}
            </React.Fragment>
        )
    }


}
export default MonitoringCommplaincesPieChart;